import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { haveValue } from "../helper/common";
import Loader from "../components/Loader";
import LandLordContext from "../context/landlord/LandLordContext";
import { toast } from "../helper/common";
import useTranslator from "../hooks/useTranslator";
const GuestLandlord = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const queryParams = new URLSearchParams(location.search);

  const { getGuestToken } = useContext(LandLordContext);

  useEffect(() => {
    defaultFunc();
  }, [location]);

  const defaultFunc = async () => {
    // Get the query parameters from the URL
    // Extract the token from the query parameters
    localStorage.setItem("landlord_guest_id", queryParams?.get("guest_no"));
    const tempSendData = {
      guest_no: queryParams?.get("guest_no"),
    };

    getGuestToken(tempSendData)
      .then((res) => {
        localStorage.setItem("token", res?.token);
        localStorage.setItem("usertype", "landlord");
        localStorage.setItem("is_verified", true);
        localStorage.setItem("saveduserid", res?.user?._id);
        localStorage.setItem("external_customer_id", res?.user?._id);
        localStorage.setItem("app_type", "skor");
        navigate("/");
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorAccessingGuestRoleContactAdminstrator"));
      });
  };

  return <Loader />;
};

export default GuestLandlord;
